module.exports = __webpack_public_path__ + "img/spinner-solid.347639c9.svg";